import { getTokenFromCookie } from '@/utils/cookies';
import { Router, scrollBehavior } from '@/utils/router';
import { setHtmlMeta, hostBuild } from '@/utils/utils';
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "core_job" */ './home/home.vue'),
      meta: { desc: '首页' },
    },
    {
      path: '/list/:topic',
      name: 'List',
      component: () => import(/* webpackChunkName: "core_job" */ './home/home.vue'),
      meta: { desc: '列表页' },
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import(/* webpackChunkName: "core_job" */ './search/search.vue'),
      meta: { desc: '搜索页' },
    },
    {
      path: '/detail/:topic/:id',
      name: 'Detail',
      component: () => import(/* webpackChunkName: "core_job" */ './detail/detail.vue'),
      meta: { desc: '详情页' },
    },
    {
      path: '/publish',
      name: 'Publish',
      component: () => import(/* webpackChunkName: "core_job" */ './publish/publish.vue'),
      meta: { desc: '发布页', isAuth: true },
    },
    {
      // params.id 发布成功后，文章的ID
      path: '/publish/success/:topic/:id',
      name: 'PublishSuccess',
      component: () => import(/* webpackChunkName: "core_job" */ './publish-success/publish-success.vue'),
      meta: { desc: '发布成功页', isAuth: true },
    },
    {
      path: '/websafe',
      name: 'WebSafe',
      component: () => import(/* webpackChunkName: "core_job" */ '@/common/websafe.vue'),
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import(/* webpackChunkName: "core_job" */ '@/common/404/index.vue'),
      meta: { desc: '404' },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  // 这里只能用本地token进行判断是否登录，否则刷新页面会出现问题
  const token = getTokenFromCookie();
  if (to.meta.isAuth === true && !token) {
    location.replace(hostBuild(`/login?redirect=${location.href}`, 'account'));
    return next(false);
  }
  if( document.querySelectorAll('.format-data')){
    var awaitRemoveDom = document.querySelectorAll('.format-data');
    for(var i=0; i<awaitRemoveDom.length;i++){
      document.head.removeChild(awaitRemoveDom[i])
    }
    
  }
  if (to.name == 'Home') {
    setHtmlMeta({
      title: '多伦多招聘 - 约克论坛 - 加拿大第一中文网',
      keywords: '多伦多找工作,多伦多招聘,华人求职,留学生兼职,留学生实习,多伦多义工,Co-op',
      description:
        '多伦多招聘网是华人和留学生的求职找工作平台，提供Markham、Richmond Hill、North York、Scarborough、Etobicoke、Mississauga等地，包括工厂工人、司机搬运、店员招待、装修杂工等全职及兼职岗位，雇主招聘、中介招聘、家庭请人及义工招募等信息。yorkbbs.ca',
    });
  } else if (to.name == 'Search') {
    setHtmlMeta({
      title: '搜索 - 多伦多招聘 - 约克论坛',
      keywords: '多伦多找工作,多伦多招聘,华人求职,留学生兼职,留学生实习,多伦多义工,Co-op',
      description: '',
    });
  } else if (to.name == 'Publish') {
    setHtmlMeta({
      title: '发布信息 - 多伦多招聘 - 约克论坛',
      keywords: '',
      description: '',
    });
  } else if (to.name == 'WebSafe') {
    setHtmlMeta({ title: '外链 - 约克论坛', keywords: '', description: '' });
  } else if (to.name == 'NotFound') {
    setHtmlMeta({ title: '404 - 约克论坛', keywords: '', description: '' });
  } else {
    setHtmlMeta({ title: '', keywords: '', description: '' });
  }

  if (to.name == 'NotFound' && !to.query.from) return next({ name: 'NotFound', query: { from: location.href } });

  next();
});

export { router };
